import { DEFAULT_ALLOWED_DEVICE_CODE_LENGTH, DEVICE_CODE_POSSIBLE_LENGTH } from "../../constants";
import type { DeviceAllowedCodeLength } from "../../types";

export const removeSpacesFromCode = (deviceCode: string = ""): string => deviceCode.replace(/\s/g, "");

const formatDeviceCode = (deviceCode: string, joinSymbol: string, isGen4DeviceCode: boolean): string => {
  const codeGroupSize = isGen4DeviceCode ? 5 : 4;
  const codePattern = new RegExp(`.{1,${codeGroupSize}}`, "g");

  return deviceCode.match(codePattern)?.join(joinSymbol) ?? "";
};

export const registrationCodeFormatter = (
  deviceCode: string,
  joinSymbol: string = " ",
  allowedLength: DeviceAllowedCodeLength[] = DEFAULT_ALLOWED_DEVICE_CODE_LENGTH
): string => {
  const maxDeviceCodeLength = Math.max(...allowedLength);
  const trimmedValue = removeSpacesFromCode(deviceCode).slice(0, maxDeviceCodeLength);
  const isGen4DeviceCode =
    allowedLength.includes(DEVICE_CODE_POSSIBLE_LENGTH.GEN4) &&
    trimmedValue.length === DEVICE_CODE_POSSIBLE_LENGTH.GEN4;

  return formatDeviceCode(trimmedValue, joinSymbol, isGen4DeviceCode);
};
